import { useQuery } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'aiCampaign/details';

export function useAICampaignDetails({ bulkEmailMessageId }: { bulkEmailMessageId: string }) {
	const userSession = useUserSession();
	return useQuery({
		enabled: !!bulkEmailMessageId,
		queryFn: async () => {
			return userSession.webServiceHelper.callAsync<Api.ICampaign>(
				Api.ImpersonationBroker.composeApiUrl({ urlPath: `email/${encodeURIComponent(bulkEmailMessageId)}` }),
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, bulkEmailMessageId],
		meta: {
			toastErrorMessage: 'Failed to load this campaign',
		},
	});
}

export const invalidateAICampaignDetails = (bulkEmailMessageId: string) => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY, bulkEmailMessageId] });
};
